var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8H6.99997C6.80978 7.99991 6.6235 8.05407 6.46299 8.15611C6.30249 8.25815 6.17442 8.40385 6.09379 8.57612C6.01317 8.74838 5.98335 8.94006 6.00783 9.12868C6.0323 9.31729 6.11006 9.49502 6.23197 9.641L11.232 15.641C11.3258 15.7535 11.4433 15.8441 11.576 15.9062C11.7087 15.9683 11.8534 16.0005 12 16.0005C12.1465 16.0005 12.2913 15.9683 12.424 15.9062C12.5567 15.8441 12.6741 15.7535 12.768 15.641L17.768 9.641C17.8899 9.49502 17.9676 9.31729 17.9921 9.12868C18.0166 8.94006 17.9868 8.74838 17.9061 8.57612C17.8255 8.40385 17.6975 8.25815 17.5369 8.15611C17.3764 8.05407 17.1902 7.99991 17 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.80fd55145e23d2d3da5575a8d55d941b.svg";
export { ForwardRef as ReactComponent };